<template>
  <div>
    <div
      :class="['md-collapse', 
              { 'is-active': isActive },
              { [getColorCollapse(colorCollapse)] : true }
      ]"
    >
      <div class="md-collapse-label" @click="toggle()" v-if="!!title">
        <h5 class="md-collapse-title">
          {{ title }}
          <md-icon>{{ icon }}</md-icon>
        </h5>
      </div>

      <collapse-transition>
        <div class="md-collapse-content" v-show="isActive">
          <slot name="md-collapse-content"></slot>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>

<script>
import { CollapseTransition } from "vue2-transitions";

export default {
  name: "collapse",
  components: {
    CollapseTransition
  },
  props: {
    active: Boolean,
    title: String,
    icon: String,
    colorCollapse: String,    
  },
  watch: {
    active(newValue) { 
      this.isActive = newValue;
    },
  },

  data() {
    return {
      isActive: this.active
    };
  },
  updated(){
    
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive;
    },
    close(){
      this.isActive = false;
    },
    open(){
      this.isActive = true;
    },
    getColorCollapse: function(colorCollapse) {
      return "md-" + colorCollapse + "";
    },
  }
};
</script>

<style lang="scss" scoped>
.text-center {
  display: flex;
}

.md-collapse-content {
  padding: 0px;
}
</style>
